/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// Whether ANNA's server is up: {state, online, message}, or null when this user
// can't see ANNA (no banner then). One request per page load.
let pending = null;

export function annaStatus() {
  pending ??= fetch(`${window.appGlobal.baseUrl}/api/v2/anna/status`, {
    credentials: 'same-origin',
    headers: {Accept: 'application/json'},
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((body) => body?.data ?? null)
    .catch(() => null);
  return pending;
}
